import { Popconfirm } from 'antd';
import { FC, ReactNode } from 'react';
import { useAppDispatch, useAppSelector } from 'customHooks/reduxHooks';
import { setFormDirty } from '../../../store/slices/formDirtySlice';
import { useLocation } from 'react-router-dom';
import routes from '../../../routes';

interface NavPopconfirmProps {
  children: ReactNode;
  onConfirm: () => void;
  title?: string;
  description?: string;
  disabled?: boolean;
  position?: 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';
}

const sharedButtonStyles = {
  backgroundColor: '#9ebbff',
  fontFamily: 'Poppins',
  borderRadius: '1.375rem',
  padding: '.25rem 1rem',
  boxShadow: 'none',
  color: '#2c2c4b',
  border: '.125rem solid #9ebbff',
};

export const NavPopconfirm: FC<NavPopconfirmProps> = ({
  children,
  onConfirm,
  title = 'Modifiche non salvate',
  description = 'Hai modifiche non salvate. Sei sicuro di voler lasciare la pagina?',
  disabled = false,
  position = 'right',
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const {pathname} = location;
  const isFormDirty = useAppSelector((store) => store.formDirty.isFormDirty);

  if (!isFormDirty || disabled || pathname !== routes.ProfileSection.links.info) {
    if ((pathname !== routes.ProfileSection.links.info) && isFormDirty) {
      dispatch(setFormDirty(false))
    }
    return <span onClick={onConfirm}>{children}</span>;
  }

  return (
    <Popconfirm
      title={title}
      description={description}
      zIndex={20000}
      okButtonProps={{style: sharedButtonStyles}}
      cancelButtonProps={{
        style: {...sharedButtonStyles, backgroundColor: 'transparent'},
      }}
      placement={position}
      onConfirm={() => {
        dispatch(setFormDirty(false));
        onConfirm();
      }}
      okText="Sì"
      cancelText="No"
    >
      {children}
    </Popconfirm>
  );
};